import { Avatar } from '@mui/material';
import { Tooltip } from 'flowbite-react';
import React from 'react';
import { Img } from 'react-image';
import { useUserContext } from 'src/context/UserProvider';
import { UiContestLeaderboard, ContestRewardTypes } from 'types';

const TopThreeRow = ({ topLeaderboardData }: { topLeaderboardData: UiContestLeaderboard[] }) => {
	const { user } = useUserContext();

	const firstPerson = topLeaderboardData[0];
	const secondPerson = topLeaderboardData[1];
	const thiredPerson = topLeaderboardData[2];

	return (
		<div className="flex justify-center items-end isolate">
			{/* Second Persion */}
			<div className="relative z-[1]">
				<div className="text-center relative flex flex-col items-center">
					<div
						className="h-[26.514px] w-[26.514px] absolute blur-[22.095230102539062px]"
						style={{ background: 'linear-gradient(147deg, #00CFDE 6.95%, #05A660 93.05%)' }}
					/>

					<div className="mb-[3px]">
						<Avatar
							sx={{ height: '33.143px', width: '33.143px', border: '0.359px solid #fff' }}
							src={secondPerson?.user?.profile?.profileImageUrl}
						/>
					</div>

					{user?._id === secondPerson?.user?._id ? (
						<div className="dark:text-[#E4E4EB] text-[#28293D] text-xs font-[500]">You</div>
					) : secondPerson?.name?.split(' ')[0]?.length > 14 ? (
						<Tooltip content={secondPerson?.user.name} placement="top">
							<div className="whitespace-pre max-w-[100%] text-xs truncate text-ellipsis dark:text-[#E4E4EB] text-[#28293D]">
								{secondPerson?.user?.name?.split(' ')[0].substring(0, 13)}...
							</div>
							{secondPerson?.user?.flags?.isTrusted ? (
								<img
									src="/assets/verified-tag.svg"
									alt={'verified-tag'}
									width={'8.286px'}
									height={'8.286px'}
									className="inline-flex"
								/>
							) : null}
						</Tooltip>
					) : (
						<div className="dark:text-[#E4E4EB] text-[#28293D] text-xs font-[500]">
							{secondPerson?.user?.name?.split(' ')[0]}{' '}
							{secondPerson?.user?.flags?.isTrusted ? (
								<img
									src="/assets/verified-tag.svg"
									alt={'verified-tag'}
									width={'8.286px'}
									height={'8.286px'}
									className="inline-flex"
								/>
							) : null}
						</div>
					)}
				</div>
				<div>
					<Img className="pointer-events-none block dark:hidden" src="/assets/contest-bg-light-1.svg" />
					<Img className="pointer-events-none hidden dark:block" src="/assets/contest-bg-2.svg" />
					<div className="min-h-[50.985px] flex flex-col items-center gap-[7px] pt-[2px] bg-gradient-to-b from-white via-[#ECECF4] to-white dark:from-[#1F2A37] dark:via-[#0D1117] dark:to-[#1F2A37]">
						<Img src="/assets/secondCoin.svg" />

						{secondPerson?.reward ? (
							<div>
								{secondPerson?.reward?.type === ContestRewardTypes.MONEY ? (
									<div className="flex items-center gap-1 text-xs dark:text-[#E4E4EB] text-[#28293D] font-[500]">
										<Img src="/assets/moneyReward.svg" className="h-[14px] w-[14px]" />₹
										{secondPerson?.reward?.reward?.toLocaleString()}
									</div>
								) : (
									<div className="flex items-center gap-1 text-xs dark:text-[#E4E4EB] text-[#28293D] font-[500]">
										<Img src="/assets/level-up-coins.svg" className="h-[14px] w-[14px] max-h-[16px]" />{' '}
										{secondPerson?.reward?.reward?.toLocaleString()} coins
									</div>
								)}
							</div>
						) : (
							<div className="flex gap-[2px] items-center justify-center">
								<div className="text-xs font-[500] dark:text-[#E4E4EB] text-[#28293D]">
									{Math.round(secondPerson?.score) || 0}
								</div>
							</div>
						)}
					</div>
				</div>
			</div>

			{/* First Person */}
			<div className="mx-[-7px]">
				<div className="text-center relative flex flex-col items-center">
					<div
						className="h-[26.514px] w-[26.514px] absolute blur-[22.095230102539062px]"
						style={{ background: 'linear-gradient(147deg, #4F87F1 6.95%, #0F6AF6 93.05%)' }}
					/>

					<div className="mb-[3px]">
						<Avatar
							sx={{ height: '33.143px', width: '33.143px', border: '0.359px solid #fff' }}
							src={firstPerson?.user?.profile?.profileImageUrl}
						/>
					</div>

					{user?._id === firstPerson?.user?._id ? (
						<div className="dark:text-[#E4E4EB] text-[#28293D] text-xs font-[500]">You</div>
					) : firstPerson?.user?.name?.split(' ')[0]?.length > 14 ? (
						<Tooltip content={firstPerson?.user.name} placement="top">
							<div className="whitespace-pre max-w-[100%] text-xs truncate text-ellipsis dark:text-[#E4E4EB] text-[#28293D]">
								{firstPerson?.user?.name?.split(' ')[0].substring(0, 13)}...
							</div>
							{firstPerson?.user?.flags?.isTrusted ? (
								<img
									src="/assets/verified-tag.svg"
									alt={'verified-tag'}
									width={'8.286px'}
									height={'8.286px'}
									className="inline-flex"
								/>
							) : null}
						</Tooltip>
					) : (
						<div className="dark:text-[#E4E4EB] text-[#28293D] text-xs font-[500]">
							{firstPerson?.user?.name?.split(' ')[0]}{' '}
							{firstPerson?.user?.flags?.isTrusted ? (
								<img
									src="/assets/verified-tag.svg"
									alt={'verified-tag'}
									width={'8.286px'}
									height={'8.286px'}
									className="inline-flex"
								/>
							) : null}
						</div>
					)}
				</div>

				<div>
					<Img className="pointer-events-none block dark:hidden" src="/assets/contest-bg-light-2.svg" />
					<Img className="pointer-events-none hidden dark:block" src="/assets/contest-bg-1.svg" />

					<div className="min-h-[66.286px] flex flex-col items-center gap-[9px] pt-[2px] bg-gradient-to-b from-white via-[#ECECF4] to-white dark:from-[#1F2A37] dark:via-[#0D1117] dark:to-[#1F2A37]">
						<Img src="/assets/firstCoin.svg" />

						{firstPerson?.reward ? (
							<div>
								{firstPerson?.reward?.type === ContestRewardTypes.MONEY ? (
									<div className="flex items-center gap-1 text-sm dark:text-[#E4E4EB] text-[#28293D] font-[500]">
										<Img src="/assets/moneyReward.svg" className="w-[18px] h-[18px]" />₹
										{firstPerson?.reward?.reward?.toLocaleString()}
									</div>
								) : (
									<div className="flex items-center gap-1 text-sm dark:text-[#E4E4EB] text-[#28293D] font-[500]">
										<Img src="/assets/level-up-coins.svg" className="w-[18px] h-[18px] max-h-[18px]" />{' '}
										{firstPerson?.reward?.reward?.toLocaleString()} coins
									</div>
								)}
							</div>
						) : (
							<div className="flex gap-[2px] items-center justify-center">
								<div className="text-xs font-[500] dark:text-[#E4E4EB] text-[#28293D]">
									{Math.round(firstPerson?.score) || 0}
								</div>
							</div>
						)}
					</div>
				</div>
			</div>

			{/* Third Person */}
			<div>
				<div className="text-center relative flex flex-col items-center">
					<div
						className="h-[26.514px] w-[26.514px] absolute blur-[22.095230102539062px]"
						style={{ background: 'linear-gradient(147deg, #F80 6.95%, #E63535 93.05%)' }}
					/>
					<div className="mb-[3px]">
						<Avatar
							sx={{ height: '33.143px', width: '33.143px', border: '0.359px solid #fff' }}
							src={thiredPerson?.user?.profile?.profileImageUrl}
						/>
					</div>

					{user?._id === thiredPerson?.user?._id ? (
						<div className="dark:text-[#E4E4EB] text-[#28293D] text-xs font-[500]">You</div>
					) : thiredPerson?.user?.name?.split(' ')[0]?.length > 14 ? (
						<Tooltip content={thiredPerson?.user.name} placement="top">
							<div className="whitespace-pre max-w-[100%] text-xs truncate text-ellipsis dark:text-[#E4E4EB] text-[#28293D]">
								{thiredPerson?.user?.name?.split(' ')[0].substring(0, 13)}...
							</div>
							{thiredPerson?.user?.flags?.isTrusted ? (
								<img
									src="/assets/verified-tag.svg"
									alt={'verified-tag'}
									width={'8.286px'}
									height={'8.286px'}
									className="inline-flex"
								/>
							) : null}
						</Tooltip>
					) : (
						<div className="dark:text-[#E4E4EB] text-[#28293D] text-xs font-[500]">
							{thiredPerson?.user?.name?.split(' ')[0]}{' '}
							{thiredPerson?.user?.flags?.isTrusted ? (
								<img
									src="/assets/verified-tag.svg"
									alt={'verified-tag'}
									width={'8.286px'}
									height={'8.286px'}
									className="inline-flex"
								/>
							) : null}
						</div>
					)}
				</div>
				<div>
					<Img className="pointer-events-none block dark:hidden" src="/assets/contest-bg-light-3.svg" />
					<Img className="pointer-events-none hidden dark:block" src="/assets/contest-bg-3.svg" />
					<div className="min-h-10 flex flex-col items-center gap-1 pt-0.5 bg-gradient-to-b from-white via-[#ECECF4] to-white dark:from-[#1F2A37] dark:via-[#0D1117] dark:to-[#1F2A37]">
						<Img src="/assets/thirdCoin.svg" className="w-[12px] h-[12px]" />
						{thiredPerson?.reward ? (
							<div>
								{thiredPerson?.reward?.type === ContestRewardTypes.MONEY ? (
									<div className="flex items-center gap-1 text-sm dark:text-[#E4E4EB] text-[#28293D] font-[500]">
										<Img src="/assets/moneyReward.svg" className="h-[12px] w-[12px]" />₹
										{thiredPerson?.reward?.reward?.toLocaleString()}
									</div>
								) : (
									<div className="flex items-center gap-1 text-sm dark:text-[#E4E4EB] text-[#28293D] font-[500]">
										<Img src="/assets/level-up-coins.svg" className="h-[12px] w-[12px] max-h-[16px]" />{' '}
										{thiredPerson?.reward?.reward?.toLocaleString()} coins
									</div>
								)}
							</div>
						) : (
							<div className="flex gap-[2px] items-center justify-center">
								<div className="text-xs font-[500] dark:text-[#E4E4EB] text-[#28293D]">
									{Math.round(thiredPerson?.score) || 0}
								</div>
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default TopThreeRow;
